import { FC } from 'react'
import {
  BreadcrumbItem,
  Breadcrumb as MikageBreadcrumb
} from '@lifedot/atoms/Breadcrumb'
import { router } from '@lifedot/router'
import { graphql } from 'relay-runtime'
import { BreadcrumbForHolderPrefecture_post$key } from './__generated__/BreadcrumbForHolderPrefecture_post.graphql'
import { useFragment } from 'react-relay/hooks'

interface BreadcrumbForHolderPrefectureProps {
  post: BreadcrumbForHolderPrefecture_post$key
}

export const BreadcrumbForHolderPrefecture: FC<
  BreadcrumbForHolderPrefectureProps
> = ({ post }) => {
  const { holder_prefecture: prefecture, ...data } = useFragment(fragment, post)
  if (!prefecture) return null

  return (
    <MikageBreadcrumb>
      <BreadcrumbItem href="/" name="【お墓・霊園・墓地探し】ライフドット" />
      <BreadcrumbItem
        href={router.prefectureIndex(prefecture.roma)}
        name={`${prefecture.name}のお墓特集（霊園・墓地）`}
      />
      <BreadcrumbItem href={router.post(data.slug)} name={data.h1} />
    </MikageBreadcrumb>
  )
}

const fragment = graphql`
  fragment BreadcrumbForHolderPrefecture_post on Post {
    slug
    h1
    holder_prefecture {
      name
      roma
    }
  }
`
